module.exports = __webpack_public_path__ + "img/icn_brand12_black.2d9b2a14.svg";